import { render } from "./debts.vue?vue&type=template&id=1fd86166&scoped=true"
import script from "./debts.vue?vue&type=script&lang=js"
export * from "./debts.vue?vue&type=script&lang=js"

import "./debts.vue?vue&type=style&index=0&id=1fd86166&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fd86166"]])

export default __exports__